import { ITranslatedText } from "modules/common/models";
import { EMAIL_PERSONALIZATION_TOKENS, MERGE_TAG_PREFIX, MERGE_TAG_SUFFIX, PersonalizationTokenValue } from "modules/emails/models";
import { CurrentUserSettings } from "modules/settings";

//If you are adding a new token type, simply add it to this object and update old references.
export interface PersonalizationTokenInformation {
    currentUser: CurrentUserSettings;
    tenantName: string;
}

// Maps the personalization token to the actual text we want
export const personalizationTokenMapper = (tokenValue: PersonalizationTokenValue, tokenDetails: PersonalizationTokenInformation) => {
    const { currentUser, tenantName } = tokenDetails;
    let replaceText = "";

    switch (tokenValue) {
        case PersonalizationTokenValue.UserFirstName:
            replaceText = currentUser.firstName;
            break;
        case PersonalizationTokenValue.UserLastName:
            replaceText = currentUser.lastName;
            break;
        case PersonalizationTokenValue.OrganizationName:
            replaceText = tenantName;
    }

    return replaceText;
}

// replaces string text occurences of the token to what the value of the token is
export const replaceTextPersonalizationTokens = (subject: ITranslatedText[], activeLcid: string, tokenDetails: PersonalizationTokenInformation): string => {
    let subjectText = subject.find(s => s.lcid === activeLcid)?.text;

    if (subjectText) {
        for (const token of EMAIL_PERSONALIZATION_TOKENS) {
            const personalizationTokenText = `${MERGE_TAG_PREFIX}${token.value}${MERGE_TAG_SUFFIX}`;
            const replaceValue = personalizationTokenMapper(token.value, tokenDetails);
            subjectText = subjectText.replaceAll(personalizationTokenText, replaceValue);
        }
    }

    return subjectText ?? "";
}
